import { createFileRoute, redirect } from '@tanstack/react-router'
import { SEARCH_PARAM_SITE_ID } from 'routes/(global_search_params)/-searchParams'
import { SEARCH_PARAM_DETECTION_CONFIGURATION_ID } from 'routes/anomaly-detection/-searchParams'
import { Route as NewRoute } from 'routes/anomaly-detection/config'

export const Route = createFileRoute(
  '/anomaly-detection/(deprecated_routes)/$siteID/$detectionConfigurationId'
)({
  beforeLoad: ({ params }) => {
    const { siteID, detectionConfigurationId } = params
    throw redirect({
      to: NewRoute.to,
      search: (prev) => ({
        ...prev,
        [SEARCH_PARAM_SITE_ID]: siteID,
        [SEARCH_PARAM_DETECTION_CONFIGURATION_ID]: detectionConfigurationId,
      }),
      replace: true,
    })
  },
})
